import { useCallback, useEffect, useRef, useState } from 'react';

import { post_payout_detail_reveal } from '../api';
import { REVEAL_SHOWN_MS, reveal_view, review_error } from './adapters';
import { reveal_body } from './requests';

/*
 * the full account number of one submission, shown for REVEAL_SHOWN_MS and then dropped from state
 * (not just hidden). Every reveal is a fresh audited POST; nothing is cached.
 */
const useReveal = (detail_uuid) => {
  const [number, setNumber] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const timer = useRef(null);
  const seq = useRef(0);

  const hide = useCallback(() => {
    seq.current += 1;
    if (timer.current) clearTimeout(timer.current);
    timer.current = null;
    setNumber('');
    setBusy(false);
  }, []);

  useEffect(() => hide, [detail_uuid, hide]);

  const reveal = useCallback(() => {
    if (!detail_uuid) return;
    hide();
    const mine = seq.current;
    setBusy(true);
    setError('');
    post_payout_detail_reveal(reveal_body(detail_uuid))
      .then((d) => {
        if (mine !== seq.current) return;
        setBusy(false);
        setNumber(reveal_view(d).account_number);
        timer.current = setTimeout(hide, REVEAL_SHOWN_MS);
      })
      .catch((e) => {
        if (mine !== seq.current) return;
        setBusy(false);
        setError(review_error(e, 'Could not show the account number. Try again.').text);
      });
  }, [detail_uuid, hide]);

  return { number, busy, error, reveal, hide };
};

export default useReveal;
